import React, { memo } from 'react';
import cx from 'classnames';
import MoCommonTop from '@src/ui-components/mo-common-top';

import styles from './index.less';

const MEMBER_FRAME_IMAGES_BY_SLOT = {
  1: require('./images/mo-guest-page-layer-15.png'),
  2: require('./images/mo-guest-page-layer-13.png'),
  3: require('./images/mo-guest-page-layer-11.png'),
  4: require('./images/mo-guest-page-layer-9.png')
};

function invokeUnlessDisabled(disabled, callback) {
  if (!disabled && callback) {
    callback();
  }
}

function renderMemberContent(member) {
  const isFilled = Boolean(member);

  return isFilled ? (
    <div className={styles.memberContent} data-role="member-content">
      {member.avatarUrl ? <img className={styles.memberAvatar} data-role="member-avatar" src={member.avatarUrl} alt="" /> : null}
      <span className={styles.memberName} data-role="member-name">
        {member.displayName}
      </span>
    </div>
  ) : null;
}

// Empty PSD slots reuse the active primary CTA; occupied slots remain display-only.
function renderEmptySlotAction({ hasMember, joined, joinDisabled, onJoin, onContinueInvite }) {
  if (hasMember) {
    return null;
  }

  const actionDisabled = joined ? false : joinDisabled;

  return (
    <button
      className={cx(styles.memberEmptyHitArea, styles.semanticButton)}
      data-role="member-empty-slot"
      type="button"
      aria-label={joined ? '邀请队员' : '加入队伍'}
      disabled={actionDisabled}
      onClick={() => invokeUnlessDisabled(actionDisabled, joined ? onContinueInvite : onJoin)}
    />
  );
}

const MoGuestPage = ({
  members = [],
  inviter = null,
  joined = false,
  joinDisabled = false,
  createDisabled = false,
  onJoin,
  onContinueInvite,
  onCreateTeam
}) => {
  const slots = [0, 1, 2, 3].map(index => members[index] || null);

  return (
    <div className={styles.root}>
      <div className={styles.group1} data-name="入队客态页">
        <div className={styles.layer1} data-name="入队客态页-背景" />
        <MoCommonTop className={styles.commonTopPlacement} />
        <div className={styles.group2} data-name="公测组队好礼展示区(结伴同游)">
          <div className={styles.layer3} data-name="组队好礼区 - 奖励展示" />
          <div className={styles.layer4} data-name="组队好礼区 - 标题" />
        </div>

        <div className={styles.group3} data-name="加入队伍区域">
          <div className={styles.group4} data-name="按钮区">
            <div
              className={cx(styles.group5, joined ? styles.hiddenStateLayer : styles.visibleStateLayer)}
              data-name="未入队态"
              data-state-group="unjoined"
              aria-hidden={joined}
            >
              <button
                className={cx(styles.layer5, styles.semanticButton)}
                data-name="创建自己队伍按钮"
                data-action="create-team-unjoined"
                data-layer="5"
                type="button"
                disabled={createDisabled}
                onClick={() => invokeUnlessDisabled(createDisabled, onCreateTeam)}
              />
              <button
                className={cx(styles.layer6, styles.semanticButton)}
                data-name="加入队伍按钮"
                data-action="join"
                data-layer="6"
                type="button"
                disabled={joinDisabled}
                onClick={() => invokeUnlessDisabled(joinDisabled, onJoin)}
              />
            </div>

            <div
              className={cx(styles.group6, joined ? styles.visibleStateLayer : styles.hiddenStateLayer)}
              data-name="入队后态"
              data-state-group="joined"
              aria-hidden={!joined}
            >
              <button
                className={cx(styles.layer7, styles.semanticButton)}
                data-name="继续邀请按钮"
                data-action="continue-invite"
                data-layer="7"
                type="button"
                onClick={() => invokeUnlessDisabled(false, onContinueInvite)}
              />
              <button
                className={cx(styles.layer8, styles.semanticButton)}
                data-name="创建自己队伍按钮"
                data-action="create-team-joined"
                data-layer="8"
                type="button"
                disabled={createDisabled}
                onClick={() => invokeUnlessDisabled(createDisabled, onCreateTeam)}
              />
            </div>
          </div>

          <div className={styles.group7} data-name="队伍展示区">
            <div className={styles.group8} data-name="队员-4" data-member-slot={4} data-filled={Boolean(slots[3])}>
              <div
                className={cx(styles.layer9, styles.memberFrame, slots[3] ? styles.visibleStateLayer : styles.hiddenStateLayer)}
                data-name="头像框-有队员（仅占位）"
                aria-hidden={!slots[3]}
              />
              <div
                className={cx(styles.layer10, slots[3] ? styles.hiddenStateLayer : styles.visibleStateLayer)}
                data-name="头像框-无队员"
                aria-hidden={Boolean(slots[3])}
              />
              {renderMemberContent(slots[3])}
              {renderEmptySlotAction({ hasMember: Boolean(slots[3]), joined, joinDisabled, onJoin, onContinueInvite })}
            </div>

            <div className={styles.group9} data-name="队员-3" data-member-slot={3} data-filled={Boolean(slots[2])}>
              <div
                className={cx(styles.layer11, styles.memberFrame, slots[2] ? styles.visibleStateLayer : styles.hiddenStateLayer)}
                data-name="头像框-有队员（仅占位）"
                aria-hidden={!slots[2]}
              />
              <div
                className={cx(styles.layer12, slots[2] ? styles.hiddenStateLayer : styles.visibleStateLayer)}
                data-name="头像框-无队员"
                aria-hidden={Boolean(slots[2])}
              />
              {renderMemberContent(slots[2])}
              {renderEmptySlotAction({ hasMember: Boolean(slots[2]), joined, joinDisabled, onJoin, onContinueInvite })}
            </div>

            <div className={styles.group10} data-name="队员-2" data-member-slot={2} data-filled={Boolean(slots[1])}>
              <div
                className={cx(styles.layer13, styles.memberFrame, slots[1] ? styles.visibleStateLayer : styles.hiddenStateLayer)}
                data-name="头像框-有队员（仅占位）"
                aria-hidden={!slots[1]}
              />
              <div
                className={cx(styles.layer14, slots[1] ? styles.hiddenStateLayer : styles.visibleStateLayer)}
                data-name="头像框-无队员"
                aria-hidden={Boolean(slots[1])}
              />
              {renderMemberContent(slots[1])}
              {renderEmptySlotAction({ hasMember: Boolean(slots[1]), joined, joinDisabled, onJoin, onContinueInvite })}
            </div>

            <div className={styles.group11} data-name="队员-1" data-member-slot={1} data-filled={Boolean(slots[0])}>
              <div
                className={cx(styles.layer15, styles.memberFrame, slots[0] ? styles.visibleStateLayer : styles.hiddenStateLayer)}
                data-name="头像框-有队员（仅占位 ）"
                aria-hidden={!slots[0]}
              />
              <div
                className={cx(styles.layer16, slots[0] ? styles.hiddenStateLayer : styles.visibleStateLayer)}
                data-name="头像框-无队员"
                aria-hidden={Boolean(slots[0])}
              />
              {renderMemberContent(slots[0])}
              {renderEmptySlotAction({ hasMember: Boolean(slots[0]), joined, joinDisabled, onJoin, onContinueInvite })}
            </div>
          </div>

          <div className={styles.group12} data-name="邀请人信息区">
            <div className={styles.layer17} data-name="分割线" />
            <div
              className={styles.layer18}
              data-name="您的老友正邀请您参与结伴同游活动， 快来入队瓜分元宝吧~"
              data-text={'您的老友正邀请您参与结伴同游活动，\r快来入队瓜分元宝吧~'}
            >
              您的老友正邀请您参与结伴同游活动，{String.fromCharCode(10)}快来入队瓜分元宝吧~
            </div>
            <div className={styles.layer19} data-name="邀请人头像框" />
            {/* 邀请人动态内容（2026-09-10 契约 is_inviter）：头像按成员 num 复用队伍列表对应槽位框图
                （与队员在队伍展示区的视觉一致），昵称沿用队员胶囊；无标记成员（未携带 share_code 或
                分享人已离队）保持 PSD 占位框 */}
            {inviter ? (
              <div className={styles.inviterContent} data-name="邀请人-动态内容" data-role="inviter-content">
                <img
                  className={styles.inviterFrameImage}
                  data-role="inviter-avatar"
                  data-inviter-frame={inviter.avatarNumber}
                  src={MEMBER_FRAME_IMAGES_BY_SLOT[inviter.avatarNumber] || MEMBER_FRAME_IMAGES_BY_SLOT[1]}
                  alt=""
                />
                <span className={styles.memberName} data-role="inviter-name">
                  {inviter.displayName}
                </span>
              </div>
            ) : null}
          </div>

          <div className={styles.layer20} data-name="加入队伍-标题" />
        </div>
      </div>
    </div>
  );
};

export default memo(MoGuestPage);
